import { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, styled } from '@mui/material/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Hero from './Hero';
import ConversationBubble from './ConversationBubble';
import { addQuery, fetchAnswer, selectQueries, selectStatus, updateQuery } from './conversationSlice';
import { sendFeedback } from './conversationApi';
import { useMediaQuery } from 'hooks/useMediaQuery';
import SendTwoToneIcon from '@mui/icons-material/SendTwoTone';
import './index.css';
import { getDoc } from './preferences/preferenceApi';
import ClipLoader from 'react-spinners/ClipLoader';
import { setSourceDocs, setSelectedDocs } from './preferences/preferenceSlice';
import StopCircleIcon from '@mui/icons-material/StopCircle';

import MainCard from 'ui-component/cards/MainCard';

import {
    Grid,
    InputAdornment,
    IconButton,
    OutlinedInput,
    FormLabel,
    FormControl,
    FormGroup,
    FormControlLabel,
    Switch
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import MicIcon from '@mui/icons-material/Mic';
import MicRecorder from 'mic-recorder-to-mp3';

import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11
    }
}));

export default function Conversation() {
    const queries = useSelector(selectQueries);
    // console.log(queries)
    const status = useSelector(selectStatus);
    const dispatch = useDispatch();
    const endMessageRef = useRef(null);
    const inputRef = useRef(null);
    const [languageState, setLanguageState] = useState({
        tienganh: true,
        tiengviet: true,
        tiengtrung: false,
        tienghan: false
    });
    const [hasScrolledToLast, setHasScrolledToLast] = useState(true);

    const { isMobile } = useMediaQuery();
    const [navOpen, setNavOpen] = useState(false);
    const [vectorId, setVectorID] = useState('');
    const [project, setProject] = useState('');
    const [avatar_path, setAvatarPath] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const [isBlock, setIsBlock] = useState(false);
    const [scrollEl, setScrollEl] = useState();
    const [message, setMessage] = useState('');
    const [recorder, setRecoder] = useState(
        new MicRecorder({
            bitRate: 128
        })
    );
    const [model, setModel] = useState();
    const [content, setContent] = useState(null);

    const [isMicro, setIsMicro] = useState(true);
    const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();

    // Speech to text
    const startListening = () => {
        resetTranscript();
        setMessage('');
        resetTranscript();
        setMessage('');

        switch (true) {
            case languageState.tiengviet:
                SpeechRecognition.startListening({
                    language: 'vi-VN',
                    continuous: true
                });
                setIsRecording(true);
                break;
            case languageState.tiengtrung:
                SpeechRecognition.startListening({
                    language: 'zh-CN',
                    continuous: true
                });
                setIsRecording(true);
                break;
            case languageState.tienghan:
                SpeechRecognition.startListening({
                    language: 'ko',
                    continuous: true
                });
                setIsRecording(true);
                break;
            default:
                SpeechRecognition.startListening({
                    language: 'vi-VN',
                    continuous: true
                });
                setIsRecording(true);
                break;
        }
    };

    const stopListening = () => {
        if (isRecording) {
            SpeechRecognition.stopListening({});
            setIsRecording(false);
        }
    };

    const handleLanguageChange = (event) => {
        switch (event.target.name) {
            case 'tiengviet':
                setLanguageState({
                    ...languageState,
                    tiengtrung: false,
                    tienghan: false,
                    tiengviet: true
                });
                break;
            case 'tiengtrung':
                setLanguageState({
                    ...languageState,
                    tiengviet: false,
                    tienghan: false,
                    tiengtrung: true
                });
                break;
            case 'tienghan':
                setLanguageState({
                    ...languageState,
                    tiengviet: false,
                    tiengtrung: false,
                    tienghan: true
                });
                break;
            default:
        }
    };

    useEffect(() => {
        listening ? setIsRecording(true) : setIsRecording(false);
    }, [listening]);

    useEffect(() => {
        if (transcript && listening) {
            setMessage(transcript);
        }
    }, [transcript]);

    // useEffect(() => {
    //     if (message === '') {
    //         resetTranscript();
    //     }
    // }, [message]);

    useEffect(() => {
        if (!browserSupportsSpeechRecognition) {
            setIsMicro(false);
            // return <span>Browser doesn't support speech recognition.</span>;
        }
    }, []);

    //
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id');
        const project = urlParams.get('project');
        setVectorID(id);
        setProject(project);
    }, []);

    useEffect(() => {
        async function requestDocs() {
            const data = await getDoc();
            // console.log(data);
            dispatch(setSourceDocs(data));
            dispatch(setSelectedDocs(data[0]));
            localStorage.setItem('DocsGPTRecentDocs', JSON.stringify(data[0]));
            localStorage.setItem('user_token', data[0]['user_token']);
            setAvatarPath(data[0]['avatar_path']);
            setModel(data[0]['model']);
        }

        requestDocs();
    }, []);

    // useEffect(() => {
    //     scrollIntoView();
    // }, [queries.length, queries[queries.length - 1]]);

    // useEffect(() => {
    //     const element = document.getElementById('inputbox');
    //     if (element) {
    //         element.focus();
    //     }
    // }, []);

    useEffect(() => {
        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                setHasScrolledToLast(entry.isIntersecting);
            });
        };

        const observer = new IntersectionObserver(observerCallback, {
            root: null,
            threshold: [1, 0.8]
        });
        if (endMessageRef.current) {
            observer.observe(endMessageRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [endMessageRef.current]);

    // const scrollIntoView = () => {
    //     endMessageRef?.current?.scrollIntoView({
    //         behavior: 'smooth',
    //         block: 'start'
    //     });
    // };

    const handleQuestion = (question) => {
        question = question.trim();
        if (question === '') return;
        dispatch(addQuery({ prompt: question }));
        dispatch(fetchAnswer({ question, model }));
    };

    const handleFeedback = (query, feedback, index) => {
        const prevFeedback = query.feedback;
        dispatch(updateQuery({ index, query: { feedback } }));
        sendFeedback(query.prompt, query.response, feedback).catch(() => {
            dispatch(updateQuery({ index, query: { feedback: prevFeedback } }));
        });
    };

    const prepResponseView = (query, index) => {
        let responseView;
        if (query.error) {
            responseView = (
                <ConversationBubble
                    ref={endMessageRef}
                    className={`${index === queries.length - 1 ? 'mb-4 md:mb-16' : 'mb-7'}`}
                    key={`${index}ERROR`}
                    message={query.error}
                    type="ERROR"
                    avatarPath={avatar_path}
                ></ConversationBubble>
            );
        } else if (query.response) {
            responseView = (
                <ConversationBubble
                    ref={endMessageRef}
                    className={`${index === queries.length - 1 ? 'mb-4 md:mb-16' : 'mb-7'}`}
                    key={`${index}ANSWER`}
                    message={query.response}
                    type={'ANSWER'}
                    sources={query.sources}
                    feedback={query.feedback}
                    handleFeedback={(feedback) => handleFeedback(query, feedback, index)}
                    isTheLast={index === queries.length - 1}
                    avatarPath={avatar_path}
                ></ConversationBubble>
            );
        }
        return responseView;
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        Document.execCommand('insertText', false, text);
    };

    const theme = useTheme();

    async function callWhisper(file) {
        // console.log('before call');
        const fileUri = URL.createObjectURL(file);
        const formData = new FormData();
        formData.append('model', 'whisper-1');
        formData.append('file', file);
        formData.append('response_format', 'text');
        const res = await fetch('https://api.openai.com/v1/audio/transcriptions', {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: 'Bearer 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'
            }
        });

        const text = await res.text();
        setMessage(text.toLowerCase().replaceAll('\n', ''));
        // console.log('callChatGPTRes', res.status);
        // console.log('callChatGPTRes', text);
        return text.trim();
    }

    const start = () => {
        // console.log(recorder);

        if (isBlock || !recorder) {
            console.log('Permission Denied or Recorder not initialized');
        } else {
            recorder
                .start()
                .then(() => {
                    setIsRecording(true);
                })
                .catch((e) => console.error(e));
        }
    };

    const stop = async () => {
        if (isRecording === true && recorder) {
            try {
                const [buffer, blob] = await recorder.stop().getMp3();
                const file = new File(buffer, 'speech.mp3', {
                    type: blob.type,
                    lastModified: Date.now()
                });
                // console.log(file);
                const blobUrl = URL.createObjectURL(file);
                // console.log(blobUrl);
                await callWhisper(file, file.name);

                setIsRecording(false);
            } catch (e) {
                console.log(e);
            }
        }
    };

    const scrollRefChat = useRef();

    useEffect(() => {
        if (scrollEl) {
            scrollEl.scrollTop = scrollRefChat?.current?.offsetTop;
        }
    }, [scrollEl, queries]);

    return (
        <MainCard
            sx={{
                bgcolor: 'white',
                '.MuiCardContent-root': {
                    height: '100%',
                    padding: '0px'
                },
                '.css-17pmaar-MuiCardContent-root:last-child': {
                    paddingBottom: '0px'
                }
            }}
            style={{
                height: '100vh'
            }}
        >
            <PerfectScrollbar
                style={{
                    width: '100%',
                    minHeight: '100vh',
                    overflowX: 'hidden'
                }}
                containerRef={(ref) => {
                    setScrollEl(ref);
                }}
            >
                <Grid container spacing={2} style={{ height: '100%' }}>
                    <Grid item xs={12} style={{ height: '100%' }}>
                        <div className="min-h-full min-w-full">
                            {/* <Navigation navOpen={navOpen} setNavOpen={setNavOpen} project={project} vector_id = {vectorId} /> */}
                            <div
                                className={`transition-all duration-200 ${
                                    !isMobile
                                        ? `ml-0 ${!navOpen ? '-mt-5 h-full md:mx-auto lg:mx-auto' : 'md:ml-72'}`
                                        : 'ml-0 h-[100vh] justify-between md:ml-16'
                                }`}
                            >
                                <div className="flex h-full flex-col justify-between bg-white p-4 md:flex-row md:justify-center">
                                    {queries.length > 0 && (
                                        <div className="md:mb-18 mt-10 flex flex-col bg-white transition-all md:mt-20 md:w-3/4">
                                            {queries.map((query, index) => {
                                                return (
                                                    <Fragment key={index}>
                                                        <ConversationBubble
                                                            className={'mb-2'}
                                                            key={`${index}QUESTION`}
                                                            message={query.prompt}
                                                            type="QUESTION"
                                                            sources={query.sources}
                                                            avatarPath={avatar_path}
                                                        ></ConversationBubble>
                                                        {prepResponseView(query, index)}
                                                    </Fragment>
                                                );
                                            })}
                                            <span ref={scrollRefChat} />
                                        </div>
                                    )}
                                    {queries.length === 0 && <Hero avatar_path={avatar_path} className="mt-24 h-[100vh] md:mt-52"></Hero>}

                                    <div className="md-left-50 md--translation-x-50 md:align-start relative bottom-0 flex w-full flex-row items-center self-center pt-3 md:fixed md:w-10/12 md:self-start">
                                        <div className="flex h-full w-full md:pb-[30px]" style={{ background: 'white' }}>
                                            <div className="flex h-full w-full md:pb-[30px]">
                                                <OutlinedInput
                                                    multiline={true}
                                                    ref={inputRef}
                                                    tabIndex={1}
                                                    fullWidth
                                                    autoFocus={false}
                                                    // contentEditable
                                                    value={isRecording === true && message === '' ? 'Đang nghe...' : message}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                    // onPaste={handlePaste}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' && !e.shiftKey) {
                                                            stopListening();
                                                            e.preventDefault();
                                                            if (message && status !== 'loading') {
                                                                handleQuestion(message);
                                                                setMessage('');
                                                            }
                                                        } else if (e.key === 'Backspace') {
                                                            stopListening();
                                                        }
                                                    }}
                                                    placeholder="Nhập tin nhắn của bạn ở đây..."
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            {isMicro && isRecording === false && status !== 'loading' && (
                                                                <LightTooltip
                                                                    enterDelay={200}
                                                                    leaveDelay={200}
                                                                    title={
                                                                        <FormControl component="language-option" variant="standard">
                                                                            <FormLabel component="language-option">
                                                                                Chọn ngôn ngữ sử dụng Micro
                                                                            </FormLabel>
                                                                            <FormGroup>
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Switch
                                                                                            disabled
                                                                                            defaultChecked
                                                                                            // checked={languageState.tienganh}
                                                                                            // onChange={handleLanguageChange}
                                                                                            name="tienganh"
                                                                                        />
                                                                                    }
                                                                                    label="Tiếng Anh"
                                                                                />
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Switch
                                                                                            checked={languageState.tiengviet}
                                                                                            onChange={handleLanguageChange}
                                                                                            name="tiengviet"
                                                                                        />
                                                                                    }
                                                                                    label="Tiếng Việt"
                                                                                />
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Switch
                                                                                            checked={languageState.tiengtrung}
                                                                                            onChange={handleLanguageChange}
                                                                                            name="tiengtrung"
                                                                                        />
                                                                                    }
                                                                                    label="Tiếng Trung"
                                                                                />
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Switch
                                                                                            checked={languageState.tienghan}
                                                                                            onChange={handleLanguageChange}
                                                                                            name="tienghan"
                                                                                        />
                                                                                    }
                                                                                    label="Tiếng Hàn"
                                                                                />
                                                                            </FormGroup>
                                                                        </FormControl>
                                                                    }
                                                                    placement="top"
                                                                    arrow
                                                                >
                                                                    <IconButton
                                                                        onClick={startListening}
                                                                        // color="primary"
                                                                        // onClick={(e) => {
                                                                        //     if (e.target.value) {
                                                                        //         handleQuestion(e.target.value);
                                                                        //         e.target.value = '';
                                                                        //     }
                                                                        // }}
                                                                        aria-label="use micro"
                                                                    >
                                                                        <MicIcon />
                                                                    </IconButton>
                                                                </LightTooltip>
                                                            )}

                                                            {isMicro && isRecording === false && status === 'loading' && (
                                                                <IconButton disabled>
                                                                    <MicIcon />
                                                                </IconButton>
                                                            )}

                                                            {isMicro && isRecording === true && (
                                                                <Tooltip title="Đã nói xong rồi" placement="top" arrow>
                                                                    <IconButton
                                                                        // disableRipple
                                                                        onClick={stopListening}
                                                                        // color="primary"
                                                                        // onClick={(e) => {
                                                                        //     if (e.target.value) {
                                                                        //         handleQuestion(e.target.value);
                                                                        //         e.target.value = '';
                                                                        //     }
                                                                        // }}
                                                                        aria-label="use micro"
                                                                    >
                                                                        <StopCircleIcon color="error" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </InputAdornment>
                                                    }
                                                    aria-describedby="search-helper-text"
                                                    inputProps={{ 'aria-label': 'weight' }}
                                                />
                                                {/* {status === 'loading' ? (
                                                    <img
                                                        src={Spinner}
                                                        className="relative bottom-[7px] right-[38px] -mr-[30px] animate-spin cursor-pointer self-end"
                                                    ></img>
                                                ) : (
                                                    <div className="relative bottom-[7px] right-[43px] -mr-[35px] h-[35px] w-[35px] cursor-pointer self-end rounded-full hover:bg-gray-3000">
                                                        <img
                                                            className="ml-[9px] mt-[9px]"
                                                            onClick={() => {
                                                                if (inputRef.current?.textContent) {
                                                                    handleQuestion(inputRef.current.textContent);
                                                                    inputRef.current.textContent = '';
                                                                }
                                                            }}
                                                            src={Send}
                                                        ></img>
                                                    </div>
                                                )} */}
                                            </div>
                                        </div>
                                        {message === '' && status !== 'loading' && (
                                            <IconButton
                                                sx={{ padding: '12px', marginLeft: '12px', paddingTop: '16px' }}
                                                disabled
                                                color="primary"
                                                aria-label="send message"
                                            >
                                                <SendTwoToneIcon />
                                            </IconButton>
                                        )}
                                        {status === 'loading' && (
                                            <Tooltip title="Bot đang trả lời..." placement="top" arrow disableRipple>
                                                <IconButton
                                                    sx={{ padding: '12px', marginLeft: '12px', paddingTop: '8px' }}
                                                    aria-label="responding"
                                                >
                                                    <ClipLoader color="#156DA2" />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {message !== '' && status !== 'loading' && (
                                            <Tooltip title="Gửi tin nhắn" placement="top" arrow>
                                                <IconButton
                                                    sx={{ padding: '12px', marginLeft: '12px', paddingTop: '16px' }}
                                                    color="primary"
                                                    onClick={(e) => {
                                                        stopListening();
                                                        if (message && status !== 'loading') {
                                                            handleQuestion(message);
                                                            setMessage('');
                                                        }
                                                    }}
                                                    aria-label="send message"
                                                >
                                                    <SendTwoToneIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </PerfectScrollbar>
        </MainCard>
    );
}
